import { Pipe, PipeTransform } from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';

@Pipe({
  name: 'formKeys',
  pure: true
})
export class FormKeysPipe implements PipeTransform {
  transform(control: AbstractControl): string[] {
    if (control instanceof FormGroup) {
      return Object.keys(control.controls);
    }
    return [];
  }
}
